import React from 'react';
import {
	CampusEntity,
	CourseEntity,
	CourseLevelEntity,
	CourseOfferingEntity,
	DisciplineEntity,
	FacultyEntity,
	SchoolEntity,
	TermEntity,
	ProgramRuleCourse,
} from 'Models/Entities';
import {
	SearchAndFilterState,
} from 'Views/Pages/Frontend/StudyPlanWizard/CourseSelection/CourseSelectionFilterInput';

export interface AvailableCourseFilters {
	levels: CourseLevelEntity[],
	terms: TermEntity[],
	faculties: FacultyEntity[],
	schools: SchoolEntity[],
	disciplines: DisciplineEntity[],
	locations: CampusEntity[],
}

/**
 * Check whether all properties of an object is empty or not set
 * @param searchAndFilterData - the object to test
 */
export const searchAndFilterIsEmpty = <T extends object>(searchAndFilterData: T) => {
	return Object.values(searchAndFilterData).every(value => value === '');
};

const courseMatchesSearchPhrase = (searchPhrase: string, course: CourseEntity) => {
	if (searchPhrase === '') {
		return true;
	}

	return course.code.toLowerCase().includes(searchPhrase.toLowerCase())
			|| course.name.toLowerCase().includes(searchPhrase.toLowerCase());
};

export const courseMatchesSelectedFilter = (selectedValue: string, actualValue?: string) => {
	// If actual value is null, we can safely assume that it is invalid data
	if (!actualValue) {
		return false;
	}

	if (selectedValue === '') {
		return true;
	}

	return selectedValue === actualValue;
};

export const courseMatchesSearchAndFilters = (
	searchAndFilterData: SearchAndFilterState,
	courseOffering: CourseOfferingEntity | ProgramRuleCourse,
) => {
	if (searchAndFilterIsEmpty(searchAndFilterData)) {
		return true;
	}

	let match = false;

	const {
		searchPhrase,
		selectedLevelId,
		selectedTermId,
		selectedFacultyId,
		selectedSchoolId,
		selectedDisciplineId,
		selectedLocationId,
	} = searchAndFilterData;
	const { course } = courseOffering;

	if (
		courseMatchesSearchPhrase(searchPhrase, course)
		&& courseMatchesSelectedFilter(selectedLevelId, course.courseLevel.id)
		&& (
			courseOffering instanceof ProgramRuleCourse
			|| courseMatchesSelectedFilter(selectedTermId, courseOffering.term.id)
		)
		&& courseMatchesSelectedFilter(selectedFacultyId, course.discipline?.school?.facultyId)
		&& courseMatchesSelectedFilter(selectedSchoolId, course.discipline?.schoolId)
		&& courseMatchesSelectedFilter(selectedDisciplineId, course.discipline?.id)
		&& (
			courseOffering instanceof ProgramRuleCourse
			|| courseMatchesSelectedFilter(selectedLocationId, courseOffering.campus.id)
		)
	) {
		match = true;
	}

	return match;
};
